var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-messages",attrs:{"id":"app-messages"}},[_c('ul',{attrs:{"name":"messages"}},_vm._l((_vm.messages),function(message){return _c('single-message',{key:message.id,attrs:{"message":message}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }